var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:#9a1121;}.d{fill:url(#c);}.e{fill:url(#d);}.f{fill:url(#e);}.g,.o{fill:#fff;}.h{fill:url(#f);}.i{fill:url(#g);}.j{fill:url(#h);}.k{fill:url(#i);}.l{fill:url(#j);}.m{fill:url(#k);}.n{opacity:0.2;}.o{opacity:0.3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.514,
    x2: 1,
    y2: 0.514,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d02827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#c61212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: -0.163,
    x2: 1,
    y2: -0.163,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c40d0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#b60807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a60202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#640000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#710000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#850100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#880100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.286,
    y1: 8.828,
    x2: 1.111,
    y2: 3.26,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.255,
    y1: 5.134,
    x2: 1.998,
    y2: 0.129,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -0.208,
    y1: 21.219,
    x2: 0.634,
    y2: 13.677,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -2.071,
    y1: -3.92,
    x2: 2.282,
    y2: -3.92,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 14.261,
    y1: 30.266,
    x2: 16.03,
    y2: 25.612,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -12.688,
    y1: -0.442,
    x2: 1.065,
    y2: -0.442,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -0.208,
    y1: 1.727,
    x2: 1.234,
    y2: -2.813,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.501,
    y1: 1.878,
    x2: 0.592,
    y2: -3.949,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -0.644,
    y1: -0.434,
    x2: 2.066,
    y2: -1.347,
    xlinkHref: "#f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,4.329C11.024,2,8.582.045,5.545-.044S.025,1.692,0,4.022V5.447c0,2.479,2.416,4.417,5.453,4.5S10.973,8.158,11,5.754Z",
    transform: "translate(0 0.047)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.451,65.406C2.165,65.385-.028,63.346,0,61v1.438c0,2.5,2.416,4.455,5.453,4.541S10.97,65.172,11,62.748V61.311C10.971,63.659,8.491,65.426,5.451,65.406Z",
    transform: "translate(0.003 -56.982)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11,4.329C10.971,6.653,8.491,8.4,5.451,8.382,2.165,8.362-.028,6.344,0,4.022S2.5-.119,5.542-.037,11.021,2,11,4.329Z",
    transform: "translate(0.003 0.04)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M136.35,14.717a1.7,1.7,0,0,0,.12.148c.043.049.088.1.134.145s.1.1.147.141.105.093.161.139a.445.445,0,0,0,.115.063.674.674,0,0,0,.142.037.886.886,0,0,0,.157.011.9.9,0,0,0,.158-.017l.042-.009.04-.011.038-.014.037-.015.126-.058.122-.058.122-.058.1-.049a5.287,5.287,0,0,0-1.26-1.03l-.089.048-.109.059-.11.06a.507.507,0,0,0-.126.1.415.415,0,0,0-.08.122.291.291,0,0,0-.023.13A.23.23,0,0,0,136.35,14.717Z",
    transform: "translate(-128.065 -13.13)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M7.26,19.874a4.664,4.664,0,0,0,.553.323.51.51,0,0,0,.178.007.439.439,0,0,0,.156-.052.36.36,0,0,0,.118-.108l.365-.546.11-.173a.231.231,0,0,0,.037-.134.369.369,0,0,0-.04-.153.61.61,0,0,0-.111-.153c-.028-.03-.171-.14-.283-.225A4.237,4.237,0,0,0,7.26,19.874Z",
    transform: "translate(-6.803 -17.403)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M70.9.582A.428.428,0,0,0,71.062.53a.434.434,0,0,0,.126-.109.434.434,0,0,0,.077-.148A.421.421,0,0,0,71.284.1L71.275.017q-.341-.042-.693-.052A7.486,7.486,0,0,0,69.21.056l.027.1.033.12a.389.389,0,0,0,.076.14.545.545,0,0,0,.13.114.682.682,0,0,0,.162.078.665.665,0,0,0,.183.032h.03l.27,0,.263-.013c.087,0,.174-.01.26-.017S70.815.591,70.9.582Z",
    transform: "translate(-65.01 0.038)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.783,13.692c-2.073-.06-3.766,1.2-3.785,2.816s1.65,2.972,3.724,3.032,3.766-1.2,3.785-2.816S33.856,13.751,31.783,13.692Zm-.06,5.408c-1.871-.052-3.375-1.238-3.357-2.648s1.545-2.515,3.414-2.459,3.372,1.238,3.357,2.648-1.544,2.511-3.413,2.459Z",
    transform: "translate(-26.234 -12.766)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M81.037,122.881c-.181,0-.352,0-.527-.012-.017,0-.04.057-.04.057l.019,1.562c.179.017.362.03.547.034a7.085,7.085,0,0,0,2.06-.237V122.69c-.308,0-.67.108-1.018.145A9.339,9.339,0,0,1,81.037,122.881Z",
    transform: "translate(-75.598 -114.525)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M150.95,69.456a.564.564,0,0,0-.126.01.439.439,0,0,0-.109.038.38.38,0,0,0-.092.067.333.333,0,0,0-.067.087c-.036.067-.431.807-.474.883a.392.392,0,0,0-.021.347.462.462,0,0,0,.11.151.6.6,0,0,0,.18.121c.055.025.608.3.668.326a4.445,4.445,0,0,0,.315-.407,3.666,3.666,0,0,0,.242-.411,3.327,3.327,0,0,0,.18-.424.937.937,0,0,0,.1-.434c-.054-.024-.579-.26-.63-.288a.584.584,0,0,0-.069-.027.709.709,0,0,0-.069-.02.63.63,0,0,0-.068-.012C150.993,69.463,150.974,69.457,150.95,69.456Z",
    transform: "translate(-140.919 -64.833)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M165.727,75.414c-.017.034-.035.067-.055.1h0c-.018.034-.036.067-.055.1v0c-.02.034-.039.067-.059.1h0a3.878,3.878,0,0,1-.438.579h0c0,.1,0,.842.008,1.514a3.74,3.74,0,0,0,.867-1.735V74.63h0a3.247,3.247,0,0,1-.265.781Z",
    transform: "translate(-155.058 -69.673)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M7.353,78.936a.429.429,0,0,0-.106-.167l-.212-.217-.214-.214-.215-.21c-.072-.071-.08-.06-.152-.134a.7.7,0,0,0-.179-.128.764.764,0,0,0-.207-.067.637.637,0,0,0-.105-.011.663.663,0,0,0-.1,0,.549.549,0,0,0-.1.023.535.535,0,0,0-.093.044l-.476.248-.137.072a.4.4,0,0,0,.023.152,4.542,4.542,0,0,0,1.339,1.613c.02.015.04-.032.063-.045l.252-.174c.195-.134.382-.269.409-.287a.552.552,0,0,0,.156-.145.408.408,0,0,0,.072-.173.366.366,0,0,0-.016-.182Z",
    transform: "translate(-4.735 -72.61)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M82.558,105.333a.479.479,0,0,0-.1-.173.683.683,0,0,0-.164-.142.664.664,0,0,0-.208-.1,8.33,8.33,0,0,0-1.26.015c-.112.009-.159.02-.265.032a.527.527,0,0,0-.208.067.543.543,0,0,0-.157.134.682.682,0,0,0-.115.4c0,.056,0,.538.021.758h0c.182.013.367.021.552.022a7.718,7.718,0,0,0,2.072-.26C82.718,106.024,82.57,105.382,82.558,105.333Z",
    transform: "translate(-75.236 -97.915)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M6.212,86.777V85.319A4.358,4.358,0,0,1,4.788,83.6c0,.094-.01.77-.018,1.381A4.5,4.5,0,0,0,6.212,86.777Z",
    transform: "translate(-4.469 -78.063)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M11,66.722c-.026,2.42-2.509,4.315-5.546,4.229S0,68.91,0,66.41v.347c0,2.5,2.416,4.455,5.453,4.541S10.973,69.49,11,67.066V65.63h0Z",
    transform: "translate(0 -61.301)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M5.451,63.25C2.268,63.228.11,61.315,0,59.06c0,.042,0,.087,0,.13-.024,2.348,2.168,4.387,5.455,4.408,3.038.019,5.52-1.748,5.545-4.095,0-.067,0-.141,0-.211C10.874,61.569,8.43,63.269,5.451,63.25Z",
    transform: "translate(0.003 -55.148)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetChip);
export default __webpack_public_path__ + "static/media/bet-chip.6afba9ab0d1869f5be785dc60ec8b6c4.svg";
export { ForwardRef as ReactComponent };